(function(){
	'use strict';

	angular
		.module('app.contact')
		.controller('AgentsController', AgentsController);

	function AgentsController(API) {
		let vm = this;

		vm.agents = [];
		vm.loadAgents = false;

		vm.$onInit = () => {
			_loadFromApi();
		}

		vm.contactAgent = (contact, agent) => {
			let data = angular.copy(contact);
			// data.email_representante = agent.email_representante;
			API.post('representates', data)
				.then(result => {
					angular.copy({}, contact);
					swal('Enviado com sucesso!', 'Em breve a nossa equipe entratá em contato com você! ;)', 'success');
					vm.openMenu = false;
				})
		}

		function _loadFromApi() {
			_loadAgents();
		}

		function _loadAgents() {
			API.get(`representantes/enderecos/estados`)
			.then(result => result.data)
			.then(agents => vm.agents = agents)
			.then(() => vm.loadAgents = true)
			.catch(error => {
				console.log(error, 'error');
			});
		}
	}

})();
